import api from '@/services/api.js';

const ENTITY_ENDPOINT = 'cotizacion-masiva';

export class CotizacionMasivaService {
  /**
   * Descarga la plantilla Excel de cotización masiva
   * @returns {Promise<Object>} Respuesta de la API con el blob xlsx
   */
  static async descargarPlantilla() {
    return await api.get(`/${ENTITY_ENDPOINT}/plantilla`, { responseType: 'blob' });
  }

  /**
   * Envía el Excel lleno para validarlo
   * @param {File} file - Archivo .xlsx
   * @returns {Promise<Object>} Respuesta con ValidacionCotizacionMasivaDTO en data
   */
  static async validar(file) {
    const formData = new FormData();
    formData.append('archivo', file);
    return await api.post(`/${ENTITY_ENDPOINT}/validar`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  /**
   * Procesa el lote: el servidor revalida, crea el lote y cotiza cada fila (persiste)
   * @param {Object} payload - { nombreArchivo, filas: [{ numeroFila, codigoProducto, moneda, unidadMedida, cantidades }] }
   * @returns {Promise<Object>} Respuesta con ResultadoLoteCotizacionMasivaDTO en data
   */
  static async procesar(payload) {
    return await api.post(`/${ENTITY_ENDPOINT}/procesar`, payload);
  }
}
